import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import ".././../assets/css/ListComponentsTable.css"
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

const AccountList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState();
  // const [contacts, setContacts] = useState();
  useEffect(() => {
    async function init() {
      const result = await fuziElevatorsApi.fetchAccounts();

      if (result) {
        setBody(result);
        // setContacts(result);
      } else {
        setBody([]);
        // setContacts([]);
      }
    }
    init();
  }, []);

  // const onFilterType = (event) => {
  //   if (event.target.value === "") {
  //     setBody(contacts);
  //   } else {
  //     setBody(
  //       contacts.filter((data) => {
  //         if (
  //           (data.recordtypeid || "").toLowerCase() ===
  //           (event.target.value || "").toLowerCase()
  //         ) {
  //           return data;
  //         }
  //       })
  //     );
  //   }
  // };

  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Make Name",
        prop: "name",
        isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.ACCOUNT.LIST}/${row.id}`} state={row}>
            {row.name}
          </Link>
        ),
        isSortable: true,
      },
      { title: "Type", prop: "type" },
      { title: "Website", prop: "website" },
      { title: "Street", prop: "street", isFilterable: true },
      { title: "City", prop: "city", isFilterable: true },
      { title: "State", prop: "state", isFilterable: true },
      { title: "Country", prop: "country", isFilterable: true }
    );
  } else {
    //for mobile device
    header.push({
      title: "Info",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.CONTACT.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.firstname} {row.name}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.city}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.state}
          </span>
        </div>
      ),
    });
  }


  const labels = {
    beforeSelect: " ",
  };

  const createAccount = () => {
    navigate(ROUTES.ACCOUNT.CREATE);
  };

  return (
    <Container fluid>
      <DatatableWrapper
        body={(body && Array.isArray(body)) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
      >
        <Row className="align-items-end">
          <Col>
            <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
          </Col>
          <Col
            md={1}
          >
            <PaginationOptions labels={labels} />
          </Col>

          <Col>
            <BrowserView>
              {/* <InfoPill left="Total" right={body?.length} /> */}
            </BrowserView>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS.MODIFY_MAKE].some(permission => {
                  return userInfo?.permissions.map(p => p.name).includes(permission);
                }) &&
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => createAccount(true)}
                >
                  New Make
                </Button>
              }
            </Stack>
          </Col>
        </Row>

        {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
          <TableHeader classes={{ th: 'bg-custom text-white' }} />
          {
            (body && Array.isArray(body)) ?
              <TableBody />
              :
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
          } 
        </Table> */}

        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
        </div>
        <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
      </DatatableWrapper>
    </Container>
  );
};

export default AccountList;
